<ion-app>
  <app-site-chrome>
    <ion-router-outlet></ion-router-outlet>
  </app-site-chrome>
</ion-app>
